import React from 'react';
import Grid from "@mui/material/Grid";
import { startOfWeekMon, endOfWeekSun } from "../../utils/dateFunctions";
import DateSelector from "../../shared/DateSelector";
import ReleasedBillsTable from './Tables/ReleasedBillsTable';

const ReleasedBillsPage = (props) => {
    const [startDate, setStartDate] = React.useState(startOfWeekMon(new Date()));
    const [endDate, setEndDate] = React.useState(endOfWeekSun(new Date()));
    const [reload, setReload] = React.useState(false);

    const reloadFunc = React.useCallback(() => {
        setReload(current => !current);
    }, []);

    return (
        <React.Fragment>
            <Grid container spacing={2} mb={1}>
                <Grid item xs={12}>
                    <DateSelector
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    <ReleasedBillsTable
                        startDate={startDate}
                        endDate={endDate}
                        reload={reload}
                        reloadFunc={reloadFunc}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default ReleasedBillsPage;